import React, { useState } from 'react';
import { Container, Tabs, Tab } from 'react-bootstrap';

import Countdown from './components/Countdown';
import CurrencyConverter from './components/CurrencyConverter';
import LengthConverter from './components/LengthConverter';
import WorldClock from './components/WorldClock';

function App() {
  const [key, setKey] = useState('countdown');

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundImage: `linear-gradient(135deg, rgba(0,0,0,0), rgba(0,0,0,0)), url('/wood.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        padding: '20px',
      }}
    >
      <Container className="mt-4">
      <h1
  style={{
    textAlign: 'center',
    marginBottom: '2rem',
    fontSize: '3rem',
    fontWeight: 'bold',
    color: '#dfc368ff',
    letterSpacing: '1px',
    textShadow: '0 0 6px rgba(212, 175, 55, 0.6), 0 0 12px rgba(212, 175, 55, 0.4)',
  }}
>
  Ghulam Qadir Timer and Converter App
</h1>


        <Tabs
          id="controlled-tab"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3 justify-content-center"
        >
          <Tab eventKey="countdown" title="Countdown Timer">
            <Countdown />
          </Tab>
          <Tab eventKey="currency" title="Currency Converter">
            <CurrencyConverter />
          </Tab>
          <Tab eventKey="length" title="Length Converter">
            <LengthConverter />
          </Tab>
          <Tab eventKey="clock" title="World Clock">
            <WorldClock />
          </Tab>
        </Tabs>
      </Container>
    </div>
  );
}

export default App;
